import { __assign, __extends } from "tslib";
import * as React from 'react';
import * as classNames from 'classnames';
import { Popover, DeprecatedHollowButton, Icon, DeprecatedInput, DeprecatedButton } from '../../primitives';
import { MenuItem, FloaterMenu } from '../floater-menu/floater-menu';
import { upload, cloud, change, iconsMap } from '../../icons';
import { FileSelector } from '../../primitives/file-selector';
import { isUrl, namespacedClassnames, noop } from '../../common';
import { DeprecatedText } from '../../deprecated-typography/text';
import { FileUploader } from './file-uploader';
var imageFileFormats = ['.jpg', '.jpeg', '.png', '.gif', '.ico', '.bmp', '.svg', '.tiff', '.bpg'];
var ImageUploader = /** @class */ (function (_super) {
    __extends(ImageUploader, _super);
    function ImageUploader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isPopoverOpen: false,
            imageFromWebOpen: false,
            isUploading: false,
            uploadError: false,
            imageFromWebUrl: '',
            validationError: ''
        };
        _this.supportedImageTypes = _this.props.fileUploader.supportedFileTypes.filter(function (fileType) { return imageFileFormats.indexOf(fileType) !== -1; });
        _this.uploaderInputRef = React.createRef();
        _this.onUploaderRef = function (ref) {
            _this.uploaderInputRef = ref;
        };
        _this.openControlledUploader = function () {
            if (_this.uploaderInputRef) {
                _this.uploaderInputRef.openFilePicker();
                if (_this.state.uploadError) {
                    _this.setState({ fileToUpload: '', uploadError: false });
                }
            }
        };
        _this.tp = function (key, params) { return _this.props.t("common.image-uploader." + key, params); };
        _this.onClickAdd = function () { return _this.setState({ isPopoverOpen: true }); };
        _this.onClosePopover = function () { return _this.setState({ isPopoverOpen: false, imageFromWebOpen: false, imageFromWebUrl: '' }); };
        _this.handleClickUpload = function () { return _this.setState({ isPopoverOpen: false }); };
        _this.handleClickFromWeb = function () { return _this.setState({ imageFromWebOpen: true }); };
        _this.onImageFromWebChange = function (url) { return _this.setState({ imageFromWebUrl: url, validationError: '' }); };
        _this.onCancelImageFromWeb = function () { return _this.setState({ imageFromWebUrl: '', imageFromWebOpen: false }); };
        _this.onClickTryAgain = function () { return _this.setState({ fileToUpload: '', isPopoverOpen: true, uploadError: false }); };
        _this.onUploadError = function () {
            _this.setState({ uploadError: true });
            if (_this.props.onUploadError) {
                _this.props.onUploadError();
            }
        };
        _this.onSaveImageFromWeb = function () {
            var imageUrl = _this.state.imageFromWebUrl;
            if (!isUrl(imageUrl)) {
                _this.setState({ validationError: _this.tp('validation-error') });
            }
            else {
                _this.setState({ fileToUpload: imageUrl, isPopoverOpen: false, imageFromWebOpen: false, imageFromWebUrl: '' });
            }
        };
        _this.onFileSelect = function (file) {
            _this.setState({ fileToUpload: file, isPopoverOpen: false });
        };
        _this.renderActionMenu = function () { return (React.createElement(FloaterMenu, null,
            React.createElement(MenuItem, { onSelect: noop },
                React.createElement(FileSelector, { supportedFileTypes: _this.supportedImageTypes, onFileSelect: _this.onFileSelect },
                    React.createElement(Icon, { icon: upload }),
                    _this.tp('new-image'))),
            React.createElement(MenuItem, { className: 'image-from-web', onSelect: _this.handleClickFromWeb },
                React.createElement(Icon, { icon: cloud }),
                _this.tp('image-web')))); };
        _this.renderImageFromWebModal = function () {
            return (React.createElement("div", { className: 'image-from-web-modal' },
                React.createElement(DeprecatedText, { type: 'h2' }, _this.tp('add-image-web')),
                React.createElement(DeprecatedInput, { onChange: _this.onImageFromWebChange, value: _this.state.imageFromWebUrl, placeholder: _this.tp('image-url'), validationError: _this.state.validationError, spellCheck: false }),
                React.createElement("div", { className: 'buttons-wrapper' },
                    React.createElement(DeprecatedHollowButton, { onClick: _this.onCancelImageFromWeb }, _this.tp('cancel')),
                    React.createElement(DeprecatedButton, { className: 'save-button', onClick: _this.onSaveImageFromWeb }, _this.tp('save')))));
        };
        _this.onUploadSuccess = function (url) {
            _this.setState({ fileToUpload: '' });
            _this.props.onChange(url);
        };
        return _this;
    }
    ImageUploader.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var t = props.t, fileUploader = props.fileUploader, size = props.size;
        var width = size.width, height = size.height;
        var uploadProgressProps = {
            t: t,
            fileUploader: __assign(__assign({}, fileUploader), { supportedFileTypes: this.supportedImageTypes }),
            size: {
                height: height < 100 ? 'short' : undefined,
                width: width < 130 ? 'xnarrow' : width < 240 ? 'narrow' : undefined
            },
            fileToUpload: state.fileToUpload || '',
            onChange: this.onUploadSuccess,
            onClickTryAgain: this.onClickTryAgain,
            onError: this.onUploadError,
            customErrorMsg: props.customErrorMsg,
        };
        var menuOpen = state.isPopoverOpen || state.imageFromWebOpen;
        var scale = props.scale || 'cover';
        var classnames = namespacedClassnames('image-uploader', {
            uploading: state.fileToUpload,
            'upload-error': state.uploadError,
            'menu-open': menuOpen,
            'plus-icon': props.showPlusIcon
        });
        var popoverBody = (React.createElement("div", { className: 'upload-image-popover-body' }, state.imageFromWebOpen ? this.renderImageFromWebModal() : this.renderActionMenu()));
        var plusIconButton = (React.createElement("div", { className: classNames('plus-button', { show: menuOpen }), onClick: this.onClickAdd },
            React.createElement(Icon, { icon: iconsMap.plusWithBg })));
        var addButton = props.url ?
            (React.createElement("div", { className: classNames('add-button add-icon-wrapper', { show: menuOpen }), onClick: this.onClickAdd },
                React.createElement(Icon, { icon: change })))
            : props.showPlusIcon ? plusIconButton : (React.createElement("div", null,
                React.createElement(DeprecatedHollowButton, { className: classNames('add-button', { show: menuOpen }), onClick: this.onClickAdd }, this.tp('add'))));
        var addImagePopover = (React.createElement(Popover, { body: popoverBody, isOpen: state.isPopoverOpen, onOuterAction: this.onClosePopover }, addButton));
        var controlledFileSelector = (React.createElement(FileSelector, { className: 'controlled-file-selector', ref: this.onUploaderRef, supportedFileTypes: this.supportedImageTypes, onFileSelect: this.onFileSelect }));
        return (React.createElement("div", { className: classnames, style: { width: width + "px", height: height + "px" } },
            React.createElement("div", { className: 'image-container', style: { backgroundImage: "url(" + props.url + ")", backgroundSize: scale }, "data-image-url": props.url },
                React.createElement("div", { className: 'uploader-content-wrapper' },
                    state.fileToUpload ? React.createElement(FileUploader, __assign({}, uploadProgressProps)) : addImagePopover,
                    controlledFileSelector))));
    };
    return ImageUploader;
}(React.PureComponent));
export { ImageUploader };
//# sourceMappingURL=image-uploader.comp.js.map